<mat-drawer-container autosize>
  <mat-card class="custom-mat-card">
    <mat-card-content class="custom-mat-card-content">
      <div id="container" class="custom-container">
        <div id="header" class="header-title">
          <div id="content_row" class="custom-header-row">
            <span class="header-title">Release Notes</span>
            <span class="spacer"></span>
            <div id="search_div" class="search-field">
              <mat-form-field id="search_field" class="search-input-holder">
                <input
                  id="search_input"
                  placeholder="Search..."
                  matInput
                  class="search-input"
                  autocomplete="off"
                  [formControl]="searchControl" />
              </mat-form-field>
            </div>
            <button
              id="add_release_notes"
              class="add-button"
              mat-button
              [routerLink]="'/release-notes/' + action.create">
              Release Notes<i class="fal fa-plus add-button-icon margin-left-10"></i>
            </button>
          </div>
        </div>
        <mat-table
          id="table"
          class="custom-table"
          matSort
          matSortDirection="desc"
          [dataSource]="dataSource"
          [matSortActive]="displayedColumns[1]">
          <ng-container matColumnDef="productId">
            <mat-header-cell
              id="table_header_product"
              mat-sort-header
              class="product-column"
              *matHeaderCellDef>
              <span class="custom-header pointer" id="product_text">Product</span>
            </mat-header-cell>
            <mat-cell
              id="product_cell"
              class="product-column"
              matTooltipClass="custom-tooltip"
              *matCellDef="let element"
              [matTooltip]="element.productId | formatProductName"
              [matTooltipShowDelay]="250">
              <span class="truncate" id="product_element">
                {{ element.productId | formatProductName }}
              </span>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="tentativeReleaseAt">
            <mat-header-cell
              id="table_header_release_date"
              mat-sort-header
              class="release-date-column"
              *matHeaderCellDef>
              <span id="release_date_text" class="custom-header pointer"> Release Date </span>
            </mat-header-cell>
            <mat-cell id="release_date_cell" class="release-date-column" *matCellDef="let element">
              <span id="release_date_element">
                {{ element.tentativeReleaseAt | date: 'dd/MM/yyyy' }}
              </span>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="title">
            <mat-header-cell
              id="table_header_title"
              mat-sort-header
              class="title-column"
              *matHeaderCellDef>
              <span class="custom-header pointer" id="title_text">Title</span>
            </mat-header-cell>
            <mat-cell
              id="title_cell"
              class="title-column"
              matTooltipClass="custom-tooltip"
              *matCellDef="let element"
              [matTooltip]="element.title"
              [matTooltipShowDelay]="250">
              <span class="truncate" id="title_element">{{ element.title }}</span>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="version">
            <mat-header-cell
              id="table_header_version"
              mat-sort-header
              class="version-column"
              *matHeaderCellDef>
              <span class="custom-header pointer" id="version_text">Version</span>
            </mat-header-cell>
            <mat-cell id="version_cell" class="version-column" *matCellDef="let element">
              <span id="version_element">{{ element.version }}</span>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="publishedAt">
            <mat-header-cell
              id="table_header_published_on"
              mat-sort-header
              class="published-column"
              *matHeaderCellDef>
              <span id="release_notes_table_published_header" class="custom-header pointer"
                >Published On</span
              >
            </mat-header-cell>
            <mat-cell id="published_cell" class="published-column" *matCellDef="let element">
              <span id="published_element">
                {{ element.publishedAt ? (element.publishedAt | date: 'dd/MM/yyyy') : '-' }}
              </span>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="modifiedBy">
            <mat-header-cell
              id="table_header_updated_by"
              mat-sort-header
              class="updated-by-column"
              *matHeaderCellDef>
              <span class="custom-header pointer" id="updated_by_text">Updated By</span>
            </mat-header-cell>
            <mat-cell
              id="updated_by_cell"
              class="updated-by-column"
              matTooltipClass="custom-tooltip"
              *matCellDef="let element"
              [matTooltip]="element.modifiedBy"
              [matTooltipShowDelay]="250">
              <span class="truncate" id="updated_by_element">{{ element.modifiedBy }}</span>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="status">
            <mat-header-cell
              id="table_header_status"
              class="just-center status-column"
              *matHeaderCellDef>
              <span id="status_text" class="custom-header">Status </span>
            </mat-header-cell>
            <mat-cell id="status_cell" class="status-column just-center" *matCellDef="let element">
              <button
                mat-button
                id="publish_button"
                class="blue-button action-button"
                [disabled]="element.status === status.published"
                [ngClass]="{ 'disabled-button': element.status === status.published }"
                (click)="openPublishDialog(element.releaseId)">
                {{ element.status === status.published ? 'Published' : 'Publish' }}
              </button>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="edit">
            <mat-header-cell
              id="table_header_edit"
              class="just-center actions-column"
              *matHeaderCellDef>
              <span id="edit_text" class="custom-header">Actions </span>
            </mat-header-cell>
            <mat-cell
              id="buttons_cell"
              class="actions-column action-buttons"
              *matCellDef="let element">
              <button
                mat-button
                id="view_button"
                class="action-button white-button"
                (click)="navigateToReleaseNotes(action.view, element.releaseId)">
                View
              </button>
              <button
                mat-button
                id="edit_button"
                class="action-button white-button"
                [disabled]="element.status === status.published"
                [ngClass]="{ 'disabled-button': element.status === status.published }"
                (click)="navigateToReleaseNotes(action.edit, element.releaseId)">
                Edit
              </button>
              <button
                mat-button
                id="delete_button"
                class="action-button white-button"
                (click)="openDeleteDialog(element)">
                Delete
              </button>
            </mat-cell>
          </ng-container>
          <mat-header-row
            id="release_notes_mat_header_row"
            *matHeaderRowDef="displayedColumns; sticky: true">
          </mat-header-row>
          <mat-row id="release_notes_mat_row" *matRowDef="let row; columns: displayedColumns">
          </mat-row>
        </mat-table>
        <mat-paginator
          #paginator
          class="custom-mat-paginator"
          [length]="resultsLength()"
          [pageSize]="50"
          [pageSizeOptions]="[20, 50, 100]">
        </mat-paginator>
        <div class="no-record">
          @if (resultsLength() === 0 && loading() === false && error() === false) {
            <div id="no_data" class="no-data">
              <img
                id="manager_no_data_image"
                src="/assets/images/no_data.svg"
                alt="No Record"
                width="100" />
              <h1 id="manager_no_data_text">No Data</h1>
              <p id="manager_no_data_content" class="custom-p">Let's get started shall we?</p>
            </div>
          }
          @if (!loading() && error()) {
            <app-form-error />
          }
          @if (loading()) {
            <app-loading-spinner />
          }
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</mat-drawer-container>
